module.exports = __webpack_public_path__ + "static/media/tti_why_talentx@3x.f0e5bbef.png";